import { Draggable } from "@hello-pangea/dnd";
import { useRedirect, RecordContextProvider } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";

import { CompanyAvatar } from "./CompanyAvatar";
import type { Company } from "../types";

export const CompanyCard = ({
  company,
  index,
}: {
  company: Company;
  index: number;
}) => {
  if (!company) return null;

  return (
    <Draggable draggableId={String(company.id)} index={index}>
      {(provided, snapshot) => (
        <CompanyCardContent
          provided={provided}
          snapshot={snapshot}
          company={company}
        />
      )}
    </Draggable>
  );
};

export const CompanyCardContent = ({
  provided,
  snapshot,
  company,
}: {
  provided?: any;
  snapshot?: any;
  company: Company;
}) => {
  const redirect = useRedirect();
  const handleClick = () => {
    redirect(`/companies/${company.id}/show`, undefined, undefined, undefined, {
      _scrollToTop: false,
    });
  };

  return (
    <div
      className="cursor-pointer"
      {...provided?.draggableProps}
      {...provided?.dragHandleProps}
      ref={provided?.innerRef}
      onClick={handleClick}
    >
      <RecordContextProvider value={company}>
        <Card
          className={`py-3 transition-all duration-200 ${
            snapshot?.isDragging
              ? "opacity-90 transform rotate-1 shadow-lg"
              : "shadow-sm hover:shadow-md"
          }`}
        >
          <CardContent className="px-3 flex flex-col gap-2">
            <div className="flex-1 flex gap-3 items-center">
              <CompanyAvatar width={40} height={40} />
              <div className="flex-1 flex flex-col">
                <p className="text-sm font-medium">{company.name}</p>
                {company.sector && (
                  <p className="text-xs text-muted-foreground line-clamp-1">
                    {company.sector}
                  </p>
                )}
              </div>
            </div>
            {company.nb_contacts !== undefined && (
              <div className="text-[10px] text-muted-foreground bg-muted w-fit px-1.5 py-0.5 rounded-sm">
                Contacts: {company.nb_contacts}
              </div>
            )}
          </CardContent>
        </Card>
      </RecordContextProvider>
    </div>
  );
};
